import React, { useState, useEffect } from "react";
import { Form, Button, ListGroup } from "react-bootstrap";
import GroupSelectMemberNew from "../group-select-member/group-select-member-new";
import { LoginContext } from "../../../src/services/api/authentication-api";
import "./select-member.scss";
import PropTypes from "prop-types";

const SelectMemberGroup = ({
  data,
  all,
  filter,
  selectAll,
  scroll,
  saveMembers,
  disabled,
  isEdit
}) => {
  const [userData, setUserData] = useState({});
  const [userFilter, setUserFilter] = useState(filter);
  const [selectedAllMembers, setSelectedAllMembers] = useState(all);

  useEffect(() => {
    let div = document.getElementById("memberlistgroup");
    div.scrollTop = scroll;
  }, [scroll]);

  useEffect(() => {
    setUserData(data);
  }, [data]);

  const selectAllTypes = (e) => {
    let div = document.getElementById("memberlistgroup");
    let newMemberGroup = [];

    if (!selectedAllMembers) newMemberGroup = userData.AllUsers;

    setUserData({
      ...userData,
      Members: newMemberGroup,
    });
    setSelectedAllMembers(!selectedAllMembers);
    saveMembers(newMemberGroup, 0, div.scrollTop, userFilter);
  };

  const filterSearchedMembers = () => {
    let filteredAllUsers = [];

    filteredAllUsers = (userData?.AllUsers ?? []).filter((user) => {
      const searchTerm = userFilter.toLowerCase();
      const userName = (user.UserName || "").toLowerCase();
      const name = (user.Name || "").toLowerCase();
      return userName.includes(searchTerm) || name.includes(searchTerm);
    });

    let selectAllListGroups = userFilter?.toLowerCase() === "" &&
      selectAll === true && (
        <ListGroup.Item key="select-all" className={"member"}>
          <Form.Check
            disabled={disabled}
            onChange={(e) => selectAllTypes(e)}
            className={"select-user-checkbox remember-me"}
            checked={selectedAllMembers}
            type={"checkbox"}
          />
          <div className={"user-title select-all"}>
            <div className={"username"}>Select All</div>
          </div>
        </ListGroup.Item>
      ); 

    if (!isEdit) {
      filteredAllUsers = filteredAllUsers.filter((user) => user.Active);
    } else if (isEdit) {
      filteredAllUsers = filteredAllUsers.filter(
        (user) =>
          user.Active ||
          userData.Members.find((member) => member.Id === user.Id) !== undefined
      );
    }

    return (
      <>
        {selectAllListGroups}
        <div>
          {filteredAllUsers.map((user, index) => {
            return (
              <GroupSelectMemberNew
                data={userData}
                user={user}
                key={JSON.stringify(user)}
                selectedMember={selectedMember}
                disabled={disabled}
              />
            );
          })}
        </div>
      </>
    );
  };

  const selectedMember = (e, userID) => {
    let div = document.getElementById("memberlistgroup");
    let user = userID;
    let newMemberGroup = userData.Members !== null ? [...userData.Members] : [];
    let firstMatching = newMemberGroup.find((member) => member.Id === userID);

    // add the member
    if (firstMatching === undefined) {
      newMemberGroup.push(
        userData.AllUsers.find((member) => member.Id === userID)
      );
    }
    // removing the member by finding first matching then splicing out
    else {
      user = -1;
      let idx = newMemberGroup.indexOf(firstMatching);
      newMemberGroup.splice(idx, 1);
    }

    setUserData({ ...userData, Members: newMemberGroup });
    setSelectedAllMembers(newMemberGroup.length === userData.length);
    saveMembers(newMemberGroup, user, div.scrollTop, userFilter);
    setUserFilter("");
  };

  return (
    <LoginContext.Consumer>
      {(state) => (
        <div className={"select-member-component"}>
          <div className={"select-member-filter-container"}>
            <Form.Control
              //className={"select-member-search-panel"} // The icon is overlapping with the input field and placeholder text
              value={userFilter}
              onChange={(e) => {
                setUserFilter(e.target.value);
                let div = document.getElementById("memberlistgroup");
                div.scrollTop = 0;
              }}
              as="input"
              rows="1"
              type="search"
              placeholder={"Search members/groups"}
              disabled={disabled}
            />
            {userFilter !== "" && (
              <Button
                className={"delete-filter-btn"}
                onClick={(e) => setUserFilter("")}
              >
                x
              </Button>
            )}
            <Form.Control.Feedback
              type="invalid"
              style={{ marginTop: "-0.5rem", marginBottom: "0.25rem" }}
            >
              Please select at least one edit/approve role
            </Form.Control.Feedback>
          </div>
          <ListGroup id="memberlistgroup" className={"members-list"}>
            {filterSearchedMembers()}
          </ListGroup>
        </div>
      )}
    </LoginContext.Consumer>
  );
};

SelectMemberGroup.propTypes = {
  data: PropTypes.shape({
    Id: PropTypes.number,
    Name: PropTypes.string,
    Description: PropTypes.string,
    Active: PropTypes.bool,
    Created: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    Deleted: PropTypes.bool,
    StatusId: PropTypes.number,
    Email: PropTypes.string,
    Modified: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    ModifiedById: PropTypes.number,
    Status: PropTypes.number,
    Size: PropTypes.number,
    AllUsers: PropTypes.array,
    Members: PropTypes.array,
    SelectedAllMembers: PropTypes.bool,
    SelectMemberScroll: PropTypes.number,
    SelectMemberFilter: PropTypes.string,
  }),
  all: PropTypes.bool,
  filter: PropTypes.string,
  selectAll: PropTypes.bool,
  scroll: PropTypes.number,
  saveMembers: PropTypes.func,
  disabled: PropTypes.bool,
  isEdit: PropTypes.bool
};

SelectMemberGroup.contextType = LoginContext;
export default SelectMemberGroup;
